function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
  id: "path-1",
  x: 0,
  y: 0,
  width: 45,
  height: 28
}), /*#__PURE__*/React.createElement("polygon", {
  id: "path-3",
  points: "0 0.282386168 25.71504 0.282386168 25.71504 25.7651613 0 25.7651613"
}));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
  id: "mask-2",
  fill: "white"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#path-1"
})), /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", {
  mask: "url(#mask-2)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(10.000000, 1.000000)"
}, /*#__PURE__*/React.createElement("g", {
  strokeWidth: 1,
  fill: "none"
}, /*#__PURE__*/React.createElement("mask", {
  id: "mask-4",
  fill: "white"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#path-3"
})), /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("path", {
  d: "M12.857832,23.0601285 C7.273552,23.0601285 2.729272,18.5574089 2.729272,13.0230523 C2.729272,7.48972627 7.273552,2.98752198 12.857832,2.98752198 C18.442112,2.98752198 22.985352,7.48972627 22.985352,13.0230523 C22.985352,18.5574089 18.442112,23.0601285 12.857832,23.0601285 M12.857832,0.282180046 C5.768152,0.282180046 -0.000208,5.99792343 -0.000208,13.0230523 C-0.000208,20.0492118 5.768152,25.7654705 12.857832,25.7654705 C19.947512,25.7654705 25.715352,20.0492118 25.715352,13.0230523 C25.715352,5.99792343 19.947512,0.282180046 12.857832,0.282180046",
  id: "Fill-1",
  fill: "#FEFEFE",
  mask: "url(#mask-4)"
})), /*#__PURE__*/React.createElement("path", {
  d: "M17.0413919,12.9135268 L12.4379122,12.9135268 L12.4379122,5.78242745 C12.4379122,5.35113035 12.1167392,5 11.7194472,5 C11.3226463,5 11,5.35113035 11,5.78242745 L11,13.9567634 C11,14.1219069 11.0476358,14.2747582 11.1281745,14.4003527 C11.2813947,14.7541553 11.6099341,15 11.9929844,15 L17.0413919,15 C17.5712782,15 18,14.5328951 18,13.9567634 C18,13.3811662 17.5712782,12.9135268 17.0413919,12.9135268",
  fill: "#FEFEFE"
})))));

var SvgFlexibleWorkingHours = function SvgFlexibleWorkingHours(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "45px",
    height: "28px",
    viewBox: "0 0 45 28",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgFlexibleWorkingHours, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/flexible-working-hours.fded7c1b.svg";
export { ForwardRef as ReactComponent };